import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-book",
  templateUrl: "./med-icon-book.component.html",
})
export class MedIconBookComponent extends SvgMixinComponent {}
